import { Ads } from 'types/Ads';

import { TrackingApi } from 'api/TrackingApi';

export const useDynamicBannerAnalytics = () => {
  const currentPageUrl = document.location.href;

  const trackBannerLoad = (payload: {
    banner: Ads;
    requestTs: number;
    profileId?: number | null;
    profilesPackHash?: string;
  }) => {
    const responseTs = Date.now();

    TrackingApi.trackDynamicBannerLoad({
      profileId: payload.profileId,
      profilesPackHash: payload.profilesPackHash,
      bannerUrl: payload.banner.url,
      pageUrl: currentPageUrl,
      requestTs: payload.requestTs,
      responseTs,
    }).catch((err) => err);
  };

  return {
    trackBannerLoad,
  };
};
